<template>
  <div class="height-fit-content">
    <b-container
      id="mainContainer"
      class="background-white direction-rtl"
      v-if="!noGateWayActive"
      :class="{ secondVersionMainContainer: getVersion === 'v2' }"
    >
      <b-row align-content="center" class="d-flex justify-content-center">
        <transition
          name="animate__fadeInOut"
          enter-active-class="animate__animated animate__fadeIn"
          appear
        >
          <b-col
            ref="mainColumn"
            id="mainColumn"
            class="col-lg-2 col-12"
            v-if="getVersion === 'v1' && !getGlobalApiRequestPending"
          >
            <b-row class="text-center">
              <transition
                name="animate__fadeInOut"
                enter-active-class="animate__animated animate__fadeIn"
                appear
              >
                <b-col
                  class="tabs col border-bottom-light-gray-1px"
                  lg="12"
                  v-if="whichGateAway.includes('shetab')"
                  @click="goTo('/')"
                  :class="{ 'activeTab fadeIn': getIsCompName === 'shetab' }"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/shetab-on.png"
                    :class="{
                      'mix-blend-mode-luminosity': getIsCompName !== 'shetab',
                    }"
                    height="50"
                    width="60"
                  />

                  <span class="d-none d-lg-inline tab-texts mt-1">
                    {{ $translate("shetab") }}
                  </span>
                </b-col>
              </transition>
              <transition
                name="animate__fadeInOut"
                enter-active-class="animate__animated animate__fadeIn"
                appear
              >
                <b-col
                  class="tabs position-relative border-bottom-light-gray-1px"
                  lg="12"
                  col
                  @click="goTo('/shaparak')"
                  v-if="whichGateAway.includes('shaparak')"
                  :class="{ activeTab: getIsCompName === 'shaparak' }"
                  style="border-bottom: 1px solid lightgray"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/shaparak-icon.png"
                    :class="{
                      'mix-blend-mode-luminosity': getIsCompName !== 'shaparak',
                    }"
                    :height="mobileSize ? 40 : 60"
                    :width="mobileSize ? 40 : 60"
                  />

                  <img
                    class="newBadgeClass flickerAnimationClass ordinary-img"
                    src="@/assets/images/newBadge.png"
                    :height="mobileSize ? 40 : 60"
                    :width="mobileSize ? 40 : 60"
                  />
                  <span class="d-none d-lg-inline tab-texts mt-1">{{
                    $translate("shaparak")
                  }}</span>
                </b-col>
              </transition>
              <!-- <b-col
                class="tabs"
                lg="12"
                col
                @click="goTo('/shaparak')"
                v-if="whichGateAway.includes('shaparak')"
                :class="{ activeTab: getIsCompName === 'shaparak' }"
                style="border-bottom: 1px solid lightgray"
              >
                <img
                  src="@/assets/images/shaparak-icon.png"
                  :class="{
                    'mix-blend-mode-luminosity': getIsCompName !== 'shaparak',
                  }"
                  :height="mobileSize ? 40 : 60"
                  :width="mobileSize ? 40 : 60"
                />
                <span class="d-none d-lg-inline tab-texts mt-1"> شاپرک </span>
              </b-col> -->
              <transition
                name="animate__fadeInOut"
                enter-active-class="animate__animated animate__fadeIn"
                appear
              >
                <b-col
                  class="tabs border-bottom-light-gray-1px"
                  lg="12"
                  col
                  :class="{
                    'activeTab fadeIn': getIsCompName === 'perfectMoney',
                  }"
                  @click="goTo('/perfect-money')"
                  v-if="whichGateAway.includes('perfect-money')"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/perfectMoney-on.png"
                    :class="{
                      'mix-blend-mode-luminosity':
                        getIsCompName !== 'perfectMoney',
                    }"
                    height="60"
                    width="60"
                  />
                  <span class="d-none d-lg-inline tab-texts mt-1">
                    {{ $translate("perfectMoney") }}
                  </span>
                </b-col>
              </transition>
              <transition
                name="animate__fadeInOut"
                enter-active-class="animate__animated animate__fadeIn"
                appear
              >
                <b-col
                  class="tabs position-relative border-bottom-light-gray-1px"
                  lg="12"
                  col
                  :class="{
                    'activeTab fadeIn': getIsCompName === 'vouchers',
                  }"
                  @click="goTo('/vouchers')"
                  v-if="whichGateAway.includes('vouchers')"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/vouchers.png"
                    :class="{
                      'mix-blend-mode-luminosity': getIsCompName !== 'vouchers',
                    }"
                    height="60"
                    width="60"
                  />
                  <!-- <img
                    class="newBadgeClass flickerAnimationClass ordinary-img"
                    src="@/assets/images/newBadge.png"
                    :height="mobileSize ? 40 : 60"
                    :width="mobileSize ? 40 : 60"
                  /> -->
                  <span class="d-none d-lg-inline tab-texts mt-1">
                    {{ $translate("vouchers") }}
                  </span>
                </b-col>
              </transition>
              <!--            IMPORTANT: for adding new badge to the tab, just add position relative to the parent and position absolute to the badge image with the following left and top percentage-->
              <transition
                name="animate__fadeInOut"
                enter-active-class="animate__animated animate__fadeIn"
                appear
              >
                <b-col
                  class="tabs position-relative border-bottom-light-gray-1px"
                  lg="12"
                  col
                  v-if="whichGateAway.includes('cardToCard')"
                  :class="{
                    'activeTab fadeIn':
                      getIsCompName === 'cardToCard' ||
                      getIsCompName === 'accountToAccount' ||
                      getIsCompName === 'indirectGroup',
                  }"
                  @click="goTo('/indirect')"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/not-direct.png"
                    :class="{
                      'mix-blend-mode-luminosity':
                        getIsCompName !== 'cardToCard' &&
                        getIsCompName !== 'accountToAccount' &&
                        getIsCompName !== 'indirectGroup',
                    }"
                    height="60"
                    width="60"
                  />

                  <img
                    class="newBadgeClass flickerAnimationClass ordinary-img"
                    src="@/assets/images/newBadge.png"
                    height="60"
                    width="60"
                  />
                  <span class="d-none d-lg-inline tab-texts mt-1">
                    {{ $translate("indirect") }}
                  </span>
                </b-col>
              </transition>
              <!-- <transition
                name="animate__fadeInOut"
                enter-active-class="animate__animated animate__fadeIn"
                appear
              >
                <b-col
                  class="tabs position-relative border-bottom-light-gray-1px"
                  lg="12"
                  col
                  v-if="whichGateAway.includes('accountToAccount')"
                  :class="{
                    'activeTab fadeIn': getIsCompName === 'accountToAccount',
                  }"
                  @click="goTo('/ata')"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/account-to-account.png"
                    :class="{
                      'mix-blend-mode-luminosity':
                        getIsCompName !== 'accountToAccount',
                    }"
                    height="60"
                    width="60"
                  />

                  <img
                    class="newBadgeClass flickerAnimationClass ordinary-img"
                    src="@/assets/images/newBadge.png"
                    height="60"
                    width="60"
                  />
                  <span class="d-none d-lg-inline tab-texts mt-1">
                    {{ $translate("accountToAccount") }}
                  </span>
                </b-col>
              </transition> -->
              <!--            <b-col class="tabs" lg="12" col-->
              <!--                   :class="{'activeTab' : getIsCompName == 'bitcoin'}"-->
              <!--                   style="border-bottom: 1px solid lightgray;"-->
              <!--                   @click="showDisabled">-->
              <!--              <img src="../assets/bitcoin.png" height="60" width="60" v-if="!(getIsCompName =='bitcoin')"/>-->
              <!--              <img src="../assets/bitcoin-on.png" height="60" width="60" v-if="(getIsCompName =='bitcoin')"/>-->
              <!--              <span class="d-none d-lg-inline tab-texts" style="margin-top: 5px"> بیت کوین </span>-->
              <!--            </b-col>-->
              <!-- <transition
                name="animate__fadeInOut"
                enter-active-class="animate__animated animate__fadeIn"
                appear
              >
                <b-col
                  class="tabs border-left-none border-bottom-light-gray-1px"
                  lg="12"
                  col
                  v-if="whichGateAway.includes('tether')"
                  :class="{ 'activeTab fadeIn': getIsCompName === 'tether' }"
                  @click="goTo('/tether')"
                >
                  <img
                    class="ordinary-img"
                    src="@/assets/images/tether-oin.png"
                    :class="{
                      'mix-blend-mode-luminosity': getIsCompName !== 'tether',
                    }"
                    height="60"
                    width="60"
                  />
                  <span class="d-none d-lg-inline tab-texts mt-1"> تتر </span>
                </b-col>
              </transition> -->
              <!-- 
              <b-col
                class="tabs border-bottom-light-gray-1px"
                lg="12"
                col
                v-if="whichGateAway.includes('tron')"
                :class="{ activeTab: getIsCompName === 'tron' }"
                @click="goTo('/tron')"
              >
                <img
                  class="ordinary-img"
                  src="@/assets/images/tron-icon.png"
                  :class="{
                    'mix-blend-mode-luminosity': getIsCompName !== 'tron',
                  }"
                  height="60"
                  width="60"
                />
                <span class="d-none d-lg-inline tab-texts mt-1"> ترون </span>
              </b-col> -->

              <!-- crypto group -->
              <b-col
                class="tabs border-bottom-light-gray-1px"
                lg="12"
                col
                v-if="
                  whichGateAway.includes('tron') ||
                  whichGateAway.includes('tether')
                "
                :class="{
                  activeTab: isCryptoGroupActive,
                }"
                @click="goTo('/crypto-group')"
              >
                <img
                  class="ordinary-img"
                  src="@/assets/images/crypto-group.png"
                  :class="{
                    'mix-blend-mode-luminosity': !isCryptoGroupActive,
                  }"
                  height="65"
                  width="70"
                />
                <span class="d-none d-lg-inline tab-texts mt-1">
                  {{ $translate("crypto") }}
                </span>
              </b-col>
            </b-row>
          </b-col>
        </transition>
        <!--        Version 1-->
        <!--        other components that are children of this component will not get rendered until sites api is finished, because it needs that information-->
        <b-col
          id="router-view-body"
          class="col-lg-10 col-12 background-light-blue"
          v-if="getVersion === 'v1' && !getGlobalApiRequestPending"
        >
          <!--          if the api was pending don't load this element, preventing undefined input errors-->
          <router-view ref="routerViewBody" name="body"></router-view>
        </b-col>

        <!--        Version 2-->
        <b-row
          class="col-lg-12 col-12 background-light-blue"
          v-if="getVersion === 'v2'"
        >
          <b-row class="col-lg-6 col-12 mr-1">
            <b-col class="col-lg-2 col-4 margin-left-top-5">
              <button
                class="paymentButtons"
                v-if="whichGateAway.includes('tether')"
                :class="{ paymentButtonActive: getIsCompName == 'tether' }"
                @click="goTo('/tether')"
              >
                {{ $translate("crypto") }}
              </button>
            </b-col>
            <b-col class="col-lg-2 col-4 margin-left-top-5">
              <button
                class="paymentButtons"
                v-if="whichGateAway.includes('shetab')"
                @click="goTo('/')"
                :class="{ paymentButtonActive: getIsCompName == 'shetab' }"
              >
                {{ $translate("shetab") }}
              </button>
            </b-col>
            <b-col class="col-lg-2 col-4 margin-left-top-5">
              <button
                class="paymentButtons"
                :class="{
                  paymentButtonActive: getIsCompName == 'perfectMoney',
                }"
                @click="goTo('/perfect-money')"
                v-if="whichGateAway.includes('perfect-money')"
              >
                {{ $translate("perfectMoney") }}
              </button>
            </b-col>
          </b-row>
          <b-col class="col-lg-12">
            <router-view name="body"></router-view>
          </b-col>
        </b-row>
      </b-row>
    </b-container>
    <!--    loading container-->
    <b-container
      class="d-flex justify-content-center align-items-center"
      v-if="getVersion === 'v1' && getGatewayPendingFlag"
    >
      <div id="preloader">
        <div id="ctn-preloader" class="ctn-preloader">
          <div class="round_spinner">
            <div class="spinner"></div>
            <div class="text">
              <img
                src="@/assets/images/Logo-2.png"
                alt="Caspian"
                name="caspain-logo"
              />
            </div>
          </div>
          <!--          <h2 class="head">Caspian payment</h2>
                    <p>You can connect any type of gateways to caspian payment</p>-->
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { paymentMixin } from "@/mixins/PaymentMixin";

export default {
  name: "Payment",
  mixins: [paymentMixin],
  mounted() {
    this.checkRouterViewBody();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setMainColumnHeight);
  },
  watch: {
    getIsCompName() {
      this.checkRouterViewBody();
    },
    getStepperPage() {
      this.checkRouterViewBody();
    },
  },
  methods: {
    checkRouterViewBody() {
      if (
        this.$refs.routerViewBody &&
        this.$refs.routerViewBody.$el &&
        this.$refs.mainColumn
      ) {
        this.setMainColumnHeight();
        window.addEventListener("resize", this.setMainColumnHeight);
        // Observe changes in the routerViewBody
        const observer = new MutationObserver(() => {
          this.setMainColumnHeight();
        });
        observer.observe(this.$refs.routerViewBody.$el, {
          childList: true,
          subtree: true,
        });
      } else {
        setTimeout(this.checkRouterViewBody, 150);
      }
    },
    setMainColumnHeight() {
      const mainColumn = this.$refs.mainColumn;
      const routerViewBody = this.$refs.routerViewBody;
      setTimeout(() => {
        if (routerViewBody.$el && !this.mobileSize) {
          // const tolerance = Math.floor(routerViewBody.$el.clientHeight / 10);
          mainColumn.style.height = `${routerViewBody.$el.clientHeight}px`;
        } else if (routerViewBody.$el && this.mobileSize) {
          mainColumn.style.height = `fit-content`;
        }
      }, 200);
    },
  },
};
</script>

<style scoped>
#mainColumn {
  overflow-y: auto;
}
/* @media (min-width: 990px) {
  #mainColumn {
    min-height: 50vh;
    max-height: 70vh;
  }
  @media (min-height: 1900px) {
    #mainColumn {
      min-height: 20vh;
      max-height: 32vh;
    }
  }
  @media (max-height: 1900px) {
    #mainColumn {
      min-height: 20vh;
      max-height: 35vh;
    }
  }
  @media (max-height: 1600px) {
    #mainColumn {
      min-height: 30vh;
      max-height: 45vh;
    }
  }
  @media (max-height: 1100px) {
    #mainColumn {
      min-height: 40vh;
      max-height: 65vh;
    }
  }
  @media (max-height: 700px) {
    #mainColumn {
      min-height: 60vh;
      max-height: 90vh;
    }
  }
} */

.activeTab {
  transition: 450ms ease-in-out;
  background-color: #abcdff;
  border-right: 7px solid midnightblue;
}

.tab-texts {
  font-size: 1rem;
  font-weight: bold;
  color: midnightblue;
}

.tabs {
  cursor: pointer;
  padding: 25px 25px;
  text-align: right;
  font-size: 1.4em;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.paymentButtons {
  width: 125px;
  border-radius: 15px;
  background-color: #6c6c6c;
  border: none;
  color: #c7c3c3;
  height: 50px;
  font-size: 1.1rem;
}

.loading-spinner-size {
  width: 3rem;
  height: 3rem;
}

.paymentButtonActive {
  background-image: linear-gradient(to right, #01bd64, #3b9eea);
  width: 125px;
  border-radius: 5px;
  color: white;
  border: none;
  font-size: 1.2rem;
  font-weight: bold;
  height: 50px;
}

.secondVersionMainContainer {
  background-color: rgb(235, 243, 251) !important;
}

.newBadgeClass {
  position: absolute !important;
  left: 10% !important;
  top: 2% !important;
}

#preloader {
  background: #ccdde7;
  height: 100%;
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

#preloader .ctn-preloader {
  padding-left: 15px;
  padding-right: 15px;
}

#preloader .round_spinner {
  border-width: 1px;
  border-color: #eef3f4;
  border-style: solid;
  border-radius: 50%;
  background-color: #fdfdfd;
  /*box-shadow: 0 0 100px 0 rgb(4 46 56);*/
  width: 248px;
  height: 248px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 40px auto 80px;
}

#preloader .spinner:before {
  content: "";
  width: 20px;
  height: 20px;
  border: 6px solid #fff;
  box-shadow: 0 0 20px 0 rgba(4, 46, 56, 0.2);
  background: #0050b2;
  position: absolute;
  right: 31px;
  top: 41px;
  border-radius: 50%;
}

@media (max-width: 576px) {
  #preloader .spinner:before {
    top: 18px;
  }
}

#preloader .spinner {
  animation: spinner 3s infinite linear;
  border-radius: 50%;
  border: 3px solid #f1f6f8;
  border-left-color: #0050b2;
  border-top-color: #0050b2;
  margin: 0 auto 0em auto;
  position: absolute;
  left: -40px;
  right: -40px;
  bottom: -40px;
  top: -40px;
}

#preloader .head {
  color: #171d24;
  display: block;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 5.2px;
  text-transform: uppercase;
  text-align: center;
  font-family: "Roboto", sans-serif;
  margin: 5% 0 1% 0;
  padding: 0;
}

#preloader p {
  color: #6a737c;
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  border: none;
  margin: 0;
  padding: 0;
}

@keyframes spinner {
  to {
    transform: rotateZ(360deg);
  }
}

@media (max-width: 576px) {
  #preloader .round_spinner {
    width: 155px;
    height: 155px;
  }
}

#preloader .round_spinner h4 {
  font-size: 30px;
  font-weight: 400;
  margin-bottom: 0;
  color: #171d24;
  margin-top: 10px;
}

#preloader .round_spinner h4 span {
  font-weight: 700;
}

/*opacity animation for the newBadge*/
@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.flickerAnimationClass {
  -webkit-animation: flickerAnimation 1s infinite;
  -moz-animation: flickerAnimation 1s infinite;
  -o-animation: flickerAnimation 1s infinite;
  animation: flickerAnimation 1s infinite;
}

.margin-left-top-5 {
  margin-top: 5%;
  margin-left: 5%;
}

@media only screen and (max-width: 1450px) and (min-width: 1200px) and (max-height: 992px) and (min-height: 576px) {
  #mainContainer {
    max-width: 1025px !important;
  }
}

@media only screen and (max-width: 1200px) and (min-width: 992px) {
  .tabs {
    padding: 35px 35px;
  }
}

@media only screen and (max-width: 992px) {
  .margin-left-top-5 {
    margin-top: 5% !important;
    margin-left: 0 !important;
  }

  .paymentButtons {
    width: 100%;
    border-radius: 15px;
    background-color: #6c6c6c;
    border: none;
    color: #c7c3c3;
    height: 40px;
    font-size: 0.9rem;
  }

  .paymentButtonActive {
    background-image: linear-gradient(to right, #01bd64, #3b9eea);
    width: 100%;
    border-radius: 5px;
    color: white;
    border: none;
    font-size: 0.9rem;
    font-weight: bold;
    height: 40px;
  }

  img.ordinary-img {
    width: 45px !important;
    height: 50px !important;
  }

  .tabs {
    padding: 5px;
  }

  .activeTab {
    border-top: 5px solid midnightblue;
    border-right: none;
  }

  .tabs {
    border-left: 2px solid lightgray;
    border-bottom: none;
  }
}

@media only screen and (max-width: 575px) {
  img.ordinary-img {
    width: 35px !important;
    height: 35px !important;
  }
}
</style>
